<template>

  <popover-box ref="popover" :parent="parent" :direction="direction">
    <stepper-range :attribute="rangeAttribute" @select="selectAttribute"></stepper-range>
    <div
      v-for="option in list"
      :key="option.name"
      class="list-popover__option"
      :class="optionClass(option.value)"
      :style="optionStyle"
      @click="selectOption(option.value)"
      :id="`popover-box-option-${option.name}`"
    >
      {{ option.name }}
    </div>
  </popover-box>

</template>

<script>
import StepperRange from './StepperRange.vue'
import PopoverBox from './PopoverBox'
import popoverContainerMixin from './popoverContainerMixin'
import { cloneDeep } from 'lodash'

export default {
  mixins: [
    popoverContainerMixin
  ],
  components: {
    PopoverBox,
    StepperRange
  },
  props: {
    attribute: Object,
    parent: {
      type: HTMLElement | SVGElement | SVGUseElement
    },
    currentValue: null,
    align: {
      type: String,
      default: 'left'
    },
    direction: {
      type: String,
      default: 'top'
    }
  },
  computed: {
    optionStyle () {
      return {
        'text-align': this.align
      }
    },
    rangeAttribute () {
      return this.attribute.options.range
    },
    list () {
      return this.attribute.options.select.options
    },
    selectAttributes () {
      return this.attribute.options.select
    }
  },
  methods: {
    selectAttribute (value) {
      let chosenAttribute = cloneDeep(this.rangeAttribute)
      chosenAttribute.value = value
      this.$refs.popover.dismiss()
      chosenAttribute.dataset = this.attribute.dataset
      chosenAttribute.path = this.attribute.path
      chosenAttribute.parent = this.attribute.parent
      this.$emit('select', chosenAttribute)
    },
    selectOption (value) {
      let chosenAttribute = cloneDeep(this.selectAttributes)
      chosenAttribute.value = value
      this.$refs.popover.dismiss()
      this.$emit('select', chosenAttribute)
    },
    optionClass (value) {
      return this.currentValue === value ? 'is-selected' : ''
    }
  }
}

</script>

<style lang="scss">
  .list-popover {

    &__option {
      width: 100%;
      min-width: 100px;
      padding-top: 6px;
      padding-bottom: 6px;
      cursor: pointer;
      text-align: center;

      &:hover {
        color: color(yellow);
      }

      &.is-selected {
        color: grey;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// RangeSelectPopover.vue?1f746cb2